import React from 'react'
import '../style/App.css'
import Settings from '../Settings/Settings'
import TrackItems from '../TrackItems/TrackItems'

import {
  BrowserRouter as Router,
  Switch,
  Route,
  NavLink
} from "react-router-dom";


/*
Purpose of this file:
0. Make it able to navigate throught the components (using React Router)
1. Make the website layout (using CSS file App.css)
*/

export default function App() {
	


  return (
    <Router>
    <div id="App">
      <nav id="Navbar">
        <NavLink to="/" activeClassName="nav-item-active" exact>
          <li className="nav-item" ><i className="nav-icon fa fa-border-all"></i>Home</li>
        </NavLink>
        <NavLink to="/Settings" activeClassName="nav-item-active">
          <li className="nav-item"><i className="nav-icon fa fa-cog"></i>Settings</li>
        </NavLink>
      </nav>
      <Switch>
          <Route path="/" exact>
             <TrackItems />
          </Route>
          <Route path="/Settings">
	          <Settings /> 
          </Route>
      </Switch>
    </div>
    </Router>
  );
}


